import { render } from "./Aboutme.vue?vue&type=template&id=756f915e&scoped=true"
import script from "./Aboutme.vue?vue&type=script&lang=js"
export * from "./Aboutme.vue?vue&type=script&lang=js"

import "./Aboutme.vue?vue&type=style&index=0&id=756f915e&lang=scss&scoped=true"

import exportComponent from "/Users/jaxz/Desktop/wangyan-campaign/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-756f915e"]])

export default __exports__